import i18n from '@/lang/index'

export default {
    'disable_clipboard': {
        name: i18n.t('SDP_APP.DISABLE_CLIPBOARD'),
        icon: 'vcs-icon-global'
    },
    'block_network': {
        name: i18n.t('SDP_APP.BLOCK_NETWORK'),
        icon: 'vcs-icon-global'
    },

    'disable_download': {
        name: i18n.t('SDP_APP.DISABLE_DOWNLOAD'),
        icon: 'vcs-icon-global'
    },
    'disable_print': {
        name: i18n.t('SDP_APP.DISABLE_PRINT'),
        icon: 'vcs-icon-global'
    },
}
